// extracted by mini-css-extract-plugin
export default {"option":"SelectOption_option__-nRaR","option__icon":"SelectOption_option__icon__-gvXx"};